import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {CourseService} from '../../../shared/services/course.service';
import {CategoryService} from '../../../shared/services/category.service';

@Component({
    selector: 'app-add-course',
    templateUrl: './add-course.component.html',
    styleUrls: ['./add-course.component.scss']
})
export class AddCourseComponent implements OnChanges {
    addCategoryForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                public categoryService: CategoryService,
                private courseService: CourseService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-category').toggleOpen();
    }

    refresh() {
        this.addCategoryForm = this.fb.group({
            'name': ['', Validators.required],
            'short_name': [''],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addCategoryForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'short_name': (this.data && this.data['short_name']) ? this.data['short_name'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addCategoryForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCategoryForm.value && this.addCategoryForm.value.name) ? this.addCategoryForm.value.name : '',
                // tslint:disable-next-line:max-line-length
                'short_name': (this.addCategoryForm.value && this.addCategoryForm.value.short_name) ? this.addCategoryForm.value.short_name : '',
            };
            this.submitting = true;
            this.categoryService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addCategoryForm.reset();
                    this.addCategoryForm.patchValue({
                        'name': '',
                        'short_name': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addCategoryForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCategoryForm.value && this.addCategoryForm.value.name) ? this.addCategoryForm.value.name : '',
                'short_name': (this.addCategoryForm.value && this.addCategoryForm.value.short_name) ? this.addCategoryForm.value.short_name : '',
            };
            this.submitting = true;
            this.categoryService.update(this.data['unique_id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
